<form class="sh-column-date-filter" [formGroup]="form" (ngSubmit)="apply()">
    <sh-form-date-select
        class="sh-column-date-filter__row"
        [id]="fromId"
        [control]="fromGroup"
        [label]="'column-filter.from' | translate"
        [yearLabel]="'column-filter.year' | translate"
        [monthLabel]="'column-filter.month' | translate"
        [dayLabel]="'column-filter.day' | translate"
        [inOverflownContainer]="true"
    ></sh-form-date-select>
    <sh-form-date-select
        class="sh-column-date-filter__row"
        [id]="toId"
        [control]="toGroup"
        [label]="'column-filter.until' | translate"
        [yearLabel]="'column-filter.year' | translate"
        [monthLabel]="'column-filter.month' | translate"
        [dayLabel]="'column-filter.day' | translate"
        [inOverflownContainer]="true"
    ></sh-form-date-select>

    @if (error(); as errorKey) {
        <div class="sh-form-group -sh-is-invalid sh-column-date-filter__error">
            <p class="sh-form-group__feedback">{{ errorKey | translate }}</p>
        </div>
    }

    <div class="sh-action-group -sh-align-end -sh-condense sh-column-date-filter__actions">
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="clear()">
            {{ 'column-filter.clear' | translate }}
        </button>
        <button type="submit" class="sh-button sh-action-group__item" [disabled]="!canApply()">
            {{ 'column-filter.apply' | translate }}
        </button>
    </div>
</form>
